import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'IndexMain',
            component: () => import('@/views/Main/Index')
        },
        {
            path: '/index',
            name: 'Index',
            component: () => import('@/views/Main/Index')
        },
        {
            path: '/user/edit',
            name: 'Index',
            component: () => import('@/views/User/Edit')
        },
        {
            path: '/login',
            name: 'Login',
            component: () => import('@/views/Login/Index')
        },
        {
            path: '/login/wx',
            name: 'LoginWx',
            component: () => import('@/views/Login/Wx')
        },
        {
            path: '/forget',
            name: 'Forget',
            component: () => import('@/views/Login/Forget')
        },
      {
            path: '/bind',
            name: 'bind',
            component: () => import('@/views/Login/Bind')
        },
        {
            path: '/register',
            name: 'Register',
            component: () => import('@/views/Login/Register')
        },
        {
            path: '/detail',
            name: 'Detail',
            component: () => import('@/views/Product/Detail')
        },
        {
            path:'/master',
            component: () => import('@/views/Identity/Master'),
        },
        {
            path:'/business',
            component: () => import('@/views/Identity/Business'),
        },
        {
            path:'/news',
            component: () => import('@/views/News/Index'),
        },
        {
            path:'/news/detail',
            component: () => import('@/views/News/Detail'),
        },
        {
            path:'/order/detail',
            component: () => import('@/views/Order/Detail'),
        },
        {
            path: '/order',
            component: () => import('@/views/Order/List')
        },
        {
            path: '/sign',
            name: 'TripDetail',
            component: () => import('@/views/Product/signUp'),
        },
        {
            path: '/detail/agenda',
            component: () => import('@/views/Product/Agenda')
        },
        {
            path: '/detail/cost',
            component: () => import('@/views/Product/CostExplain')
        },
        {
            path: '/detail/attention',
            component: () => import('@/views/Product/Attention')
        },
        {
            path: '/detail/reminder',
            component: () => import('@/views/Product/Reminder')
        },
        {
            path: '/detail/speaker',
            component: () => import('@/views/Product/Speaker')
        },
        {
            path: '/detail/data',
            component: () => import('@/views/Product/Data')
        },
        {
            path: '/detail/contact',
            component: () => import('@/views/Product/Contact')
        },
        {
            path: '/myproduct',
            component: () => import('@/views/Identity/MyProduct')
        },
        {
            path: '/customer',
            component: () => import('@/views/customer/index')
        },
        {
            path: '/customer/supplier',
            component: () => import('@/views/customer/Supplier')
        },
        {
            path: '/customer/success',
            component: () => import('@/views/customer/success')
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js